import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ranking-item" }
const _hoisted_2 = { class: "ranking-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_4 = { class: "item-tile" }
const _hoisted_5 = { class: "leading" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "info-text" }
const _hoisted_8 = { class: "sub-text" }
const _hoisted_9 = { class: "count" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarCircle = _resolveComponent("AvatarCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_AvatarCircle, {
              avatar: 
              item?.profilePicture
                ? _ctx.getFilePathFromUrl(item.profilePicture) +
                  '?ver=' +
                  new Date().getTime()
                : require('icons/default-avatar.svg')
            ,
              class: "avatar"
            }, null, 8, ["avatar"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", null, _toDisplayString(item.lastName) + " " + _toDisplayString(item.firstName), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(item.email), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.count) + _toDisplayString(_ctx.$t("dashboard.countText")), 1)
          ])
        ]),
        _hoisted_10
      ]))
    }), 128))
  ]))
}